import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getItemWebStorage } from '../../../features/webStorageSaver/webStorageSaver';

const baseQuery = fetchBaseQuery({
    baseUrl: '/',
});

const dynamicBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const urlEnd = typeof args === 'string' ? args : args.url
    const currentConfig = getItemWebStorage('currentConfig')
    const wmsServer = currentConfig.wmsServer
    const wfsApiUrlLocal = `${wmsServer}wfs`
    const adjustedUrl = `${wfsApiUrlLocal}/${urlEnd}`
    const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, currentApiUrl: wfsApiUrlLocal, url: adjustedUrl }
    return baseQuery(adjustedArgs, api, extraOptions)
}

export const mapWFSAPI = createApi({
    reducerPath: 'mapWFSAPI',
    baseQuery: dynamicBaseQuery,
    endpoints: (builder) => ({})
});

export const mapWFSAPIReducer = mapWFSAPI.reducer
export const resetMapWFSAPI = mapWFSAPI.util.resetApiState
